<template>
  <div class="steps">
    <button @click="showNewStepModal = true">Add New Step</button>
    <br />
    <VueGoodTable
      :columns="columns"
      :rows="allSteps.concat().sort((a, b) => a.order < b.order ? -1 :1)"
      @on-row-click="editStep"
    />
    <br />
    <button @click="showNewStepModal = true">Add New Step</button>
    <StepModal
      v-if="showModal"
      :step.sync="activeStep"
      @closeModal="closeModal"
    />
    <StepModal
      v-if="showNewStepModal"
      :newStep="true"
      :step.sync="newStep"
      :project="project"
      @closeModal="closeNewStepModal"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { VueGoodTable } from 'vue-good-table';
import 'vue-good-table/dist/vue-good-table.css';

import StepModal from '@/components/StepModal.vue';

export default {
  name: 'project-steps',
  props: {
    steps: {
      type: Array,
    },
    project: {
      type: Object,
    },
  },
  components: {
    VueGoodTable,
    StepModal,
  },
  data() {
    return {
      columns: [
        {
          label: 'Title',
          field: 'title',
        },
        {
          label: 'Order',
          field: 'order',
        },
      ],
      activeStep: null,
      newStep: {},
      showModal: false,
      showNewStepModal: false,
      newSteps: null,
    };
  },
  computed: {
    ...mapState({
      user: state => state.profile.user,
    }),
    API() {
      return this.$API;
    },
    allSteps() {
      if (this.newSteps) {
        return this.newSteps;
      }
      return this.steps;
    },
  },
  methods: {
    getSteps() {
      this.axios
        .get(`${this.$API}/steps?project=${this.project.id}&_sort=order:ASC&_limit=-1`)
        .then((response) => {
          this.newSteps = response.data;
          this.project.steps = response.data;
        });
    },
    closeModal() {
      this.getSteps();
      this.showModal = false;
    },
    closeNewStepModal() {
      this.getSteps();
      this.showNewStepModal = false;
    },
    editStep(params) {
      this.activeStep = params.row;
      this.showModal = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.steps {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 700px;
}
</style>
